import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  GetAllEvaluationCriteriaUseCaseInterface,
  GetEvaluationCriteriaByIdUseCaseInterface,
} from 'domain/usecases';

interface IEvaluationCriteriaState {
  evaluationCriterias: GetAllEvaluationCriteriaUseCaseInterface.Result;
  selectedEvaluationCriteria: GetEvaluationCriteriaByIdUseCaseInterface.Result;
}

interface IPayloadEvaluationCriterias
  extends PayloadAction<GetAllEvaluationCriteriaUseCaseInterface.Result> {}

interface IPayloadSelectedEvaluationCriteria
  extends PayloadAction<GetEvaluationCriteriaByIdUseCaseInterface.Result> {}

const initialState: IEvaluationCriteriaState = {
  evaluationCriterias: [],
  selectedEvaluationCriteria: null,
};

export const EvaluationCriteriaSlice = createSlice({
  name: 'evaluation-criteria-slice',
  initialState,
  reducers: {
    loadEvaluationCriterias: (state, action: IPayloadEvaluationCriterias) => {
      state.evaluationCriterias = action.payload;
    },
    clearEvaluationCriterias: (state) => {
      state.evaluationCriterias = [];
    },
    loadSelectedEvaluationCriteria: (
      state,
      action: IPayloadSelectedEvaluationCriteria,
    ) => {
      state.selectedEvaluationCriteria = action.payload;
    },
    clearSelectedEvaluationCriteria: (state) => {
      state.selectedEvaluationCriteria = null;
    },
  },
});

export const {
  loadEvaluationCriterias,
  clearEvaluationCriterias,
  loadSelectedEvaluationCriteria,
  clearSelectedEvaluationCriteria,
} = EvaluationCriteriaSlice.actions;

export default EvaluationCriteriaSlice.reducer;
